import { Spinner } from './Spinner';
import gLogoViolet from '@/assets/g_logo_violet.png';

type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

interface BrandedSpinnerProps {
  size?: SpinnerSize;
  className?: string;
  logoSrc?: string;
}

const overlaySizeBySpinnerSize: Record<SpinnerSize, string> = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-6 w-6',
  xl: 'h-14 w-14',
};

export const BrandedSpinner = ({ size = 'md', className, logoSrc }: BrandedSpinnerProps) => {
  return (
    <div className={`relative inline-block ${className || ''}`}>
      <Spinner size={size} />
      <img
        src={logoSrc || gLogoViolet}
        alt="Granguard"
        className={`pointer-events-none select-none absolute inset-0 m-auto object-contain ${overlaySizeBySpinnerSize[size]}`}
      />
    </div>
  );
};


